enum Locale {
  GERMAN = "de",
  ENGLISH = "en",
  FRENCH = "fr",
  ITALIEN = "it",
  SPANISH = "es",
}

export default Locale;
